
<div *ngFor="let head of content">
    {{head}}
</div>